import countryFlagImages from '@images/flags/language'

/**
 * Find country icon by locale.
 *
 * @param  {String} locale Locale code, for example: "en", "ru", "lv", etc.
 * @return {Object}
 */
export function findCountryIconByLocale (locale) {
  return countryFlagImages[locale.toLowerCase()]
}



// WEBPACK FOOTER //
// ./src/i18n/helpers.js